import { StarSvg } from '../../../../ui/components/ui/stars-rating';

const STAR_COUNT = 5;

const RatingBadge = () => (
  <div className="flex items-center gap-3">
    {/* `logo.svg` is the white mark of the dark sidebar. */}
    <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-[#082729] p-1.5">
      <img src="/logo.svg" alt="7i7" className="h-full w-full object-contain" />
    </div>
    <div className="flex flex-col gap-1">
      <p className="text-xs font-medium text-[#082729]">4,9/5 aus 1.000+ Bewertungen</p>
      <div className="flex gap-2 text-[#FFE539]" aria-hidden="true">
        {Array.from({ length: STAR_COUNT }).map((_, index) => (
          <span key={index} className="h-3 w-3">
            <StarSvg fillOpacity={1} />
          </span>
        ))}
      </div>
    </div>
  </div>
);

export default RatingBadge;
